import React from 'react';

const sanitizeComment = (comment) => (comment ? comment.replace(/\n/g, '') : '');

export default (props) => {
  return (
    <span
      className="annotation-highlight"
      data-id={props.dataAnnotationId}
      data-tip={sanitizeComment(props.dataAnnotationNotes)}
    >
      {props.children}
    </span>
  );
};
